var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifyEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 27.1667L30.8591 33.8347C31.6304 34.3746 32.0161 34.6446 32.4356 34.7492C32.8062 34.8416 33.1938 34.8416 33.5643 34.7492C33.9839 34.6446 34.3695 34.3746 35.1409 33.8347L44.6666 27.1667M26.9333 42.3333H39.0666C41.0268 42.3333 42.0069 42.3333 42.7556 41.9519C43.4142 41.6163 43.9496 41.0809 44.2852 40.4223C44.6666 39.6736 44.6666 38.6935 44.6666 36.7333V29.2667C44.6666 27.3065 44.6666 26.3264 44.2852 25.5777C43.9496 24.9191 43.4142 24.3837 42.7556 24.0481C42.0069 23.6667 41.0268 23.6667 39.0666 23.6667H26.9333C24.9731 23.6667 23.993 23.6667 23.2443 24.0481C22.5858 24.3837 22.0503 24.9191 21.7148 25.5777C21.3333 26.3264 21.3333 27.3065 21.3333 29.2667V36.7333C21.3333 38.6935 21.3333 39.6736 21.7148 40.4223C22.0503 41.0809 22.5858 41.6163 23.2443 41.9519C23.993 42.3333 24.9731 42.3333 26.9333 42.3333Z",
    stroke: "#5433FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#F9F5FF",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmail);
export default __webpack_public_path__ + "static/media/verifyEmail.2c4292de07bf1e3a1b0ede786470d331.svg";
export { ForwardRef as ReactComponent };